/* ============================================
   LIVING ROOTS — Theme JS
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  /* SCROLL HEADER */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  /* HAMBURGER */
  const hamburger = document.querySelector('.hamburger');
  const navLinks = document.querySelector('.nav-links');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => navLinks.classList.toggle('open'));
    navLinks.querySelectorAll('a').forEach(a =>
      a.addEventListener('click', () => navLinks.classList.remove('open'))
    );
  }

  /* QTY SELECTOR */
  document.querySelectorAll('.qty').forEach(qty => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value) - 1);
    });
    qty.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });

  /* FAQ ACCORDION */
  document.querySelectorAll('.faq-item').forEach(item => {
    item.querySelector('.faq-q')?.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* REVEAL ON SCROLL */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => e.isIntersecting && e.target.classList.add('in'));
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  /* PRODUCT THUMBS */
  document.querySelectorAll('.product-thumbs').forEach(thumbs => {
    const mainImg = thumbs.parentElement?.querySelector('.product-main-image img');
    thumbs.querySelectorAll('.thumb').forEach(t => {
      t.addEventListener('click', () => {
        thumbs.querySelectorAll('.thumb').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const newSrc = t.querySelector('img')?.dataset.full;
        if (mainImg && newSrc) mainImg.src = newSrc;
      });
    });
  });

  /* CART DRAWER */
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-overlay');
  document.querySelectorAll('[data-cart-open]').forEach(btn =>
    btn.addEventListener('click', e => {
      e.preventDefault();
      openCart();
    })
  );
  document.querySelectorAll('[data-cart-close]').forEach(btn =>
    btn.addEventListener('click', () => closeCart())
  );
  overlay?.addEventListener('click', closeCart);
  function openCart() { drawer?.classList.add('open'); overlay?.classList.add('open'); document.body.style.overflow='hidden'; refreshCart(); }
  function closeCart() { drawer?.classList.remove('open'); overlay?.classList.remove('open'); document.body.style.overflow=''; }
  window.LivingRoots = { openCart, closeCart, refreshCart };

  /* ADD TO CART (AJAX) */
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn?.textContent;
      if (btn) btn.textContent = '...';
      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openCart();
        if (btn) btn.textContent = '✓ Añadido';
        setTimeout(() => { if (btn) btn.textContent = original; }, 1500);
      } catch (err) {
        console.error(err);
        if (btn) btn.textContent = original;
        alert('No se pudo agregar al carrito.');
      }
    });
  });

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      const itemsContainer = document.querySelector('[data-cart-items]');
      const subtotalEl = document.querySelector('[data-cart-subtotal]');
      const emptyEl = document.querySelector('[data-cart-empty]');
      if (itemsContainer) {
        if (cart.item_count === 0) {
          itemsContainer.innerHTML = '';
          if (emptyEl) emptyEl.style.display = 'block';
        } else {
          if (emptyEl) emptyEl.style.display = 'none';
          itemsContainer.innerHTML = cart.items.map(item => `
            <div class="cart-item">
              <img src="${item.image || ''}" alt="${item.product_title}">
              <div class="cart-item-info">
                <strong>${item.product_title}</strong>
                <div class="price-cart">${item.quantity} × ${formatMoney(item.final_line_price)}</div>
                <button class="cart-item-remove" data-remove="${item.key}">Quitar</button>
              </div>
            </div>
          `).join('');
          itemsContainer.querySelectorAll('[data-remove]').forEach(btn =>
            btn.addEventListener('click', () => removeItem(btn.dataset.remove))
          );
        }
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    } catch (e) { console.error(e); }
  }

  async function removeItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    refreshCart();
  }

  function formatMoney(cents) {
    return '$' + (cents/100).toFixed(2);
  }

  refreshCart();
});
